import React from "react";

export const QuickHelp = () => {
  return (
    <ul className="space-y-2 text-gray-300">
      <li>• Check our FAQ for common questions</li>
      <li>• View the Study Guide for game tips</li>
      <li>• Report technical issues</li>
      <li>• Request feature improvements</li>
    </ul>
  );
};